export const CONTAINER_IDS = {
    LAST_LOGIN: '#last_login_container',
    SESSION_TIMER: '#session_timer_container'
};

export const LAST_LOGIN_SELECTORS = {
    TITLE: ".cgp-last-login-title",
    VALUE: ".cgp-lastLogin",
    CONTAINER: ".cgp-last-login-container",

};

export const LAST_LOGIN_TITLE_TRANSLATION_KEY = "last_login_title";

export const DEFAULT_SWITCH_TO_SESSION_TIMER_WAIT_INTERVAL = 60000;